const mapCustomerFromAPI = ({
  contactName,
  city,
  state,
  country
}) => ({
  contactName,
  city,
  state,
  country
})

const mapCustomerForUpsert = ({
  contactName,
  city,
  state,
  country
}) => ({
  contactName,
  city,
  state,
  country
})

export default {
  mapCustomerFromAPI,
  mapCustomerForUpsert
}
